import { useState } from "react";

const tickerItems = [
  "档案更新｜演员陆之遥 新增 3 条关联信息",
  "快讯｜网红「老铁阿贵」事件时间线已补齐",
  "档案更新｜主播 KK 战队关联人物新增 2 位",
  "热议｜本周「谁先塌」围观热度 TOP10 已出炉",
  "档案更新｜某选秀出道艺人 早期言论页已归档",
  "快讯｜财经大V林岳 相关合同细节已整理",
];

const navLinks = [
  { label: "快讯", href: "#flash" },
  { label: "人物档案", href: "#archive" },
  { label: "热议热榜", href: "#hot" },
  { label: "围观广场", href: "#talk" },
  { label: "投稿指南", href: "#info" },
];

export default function Header() {
  const [open, setOpen] = useState(false);

  return (
    <>
      {/* 压顶：LIVE 更新条 / 入口条 */}
      <div className="bg-primary-500 text-background-50">
        <div className="mx-auto flex w-full max-w-6xl items-center gap-3 px-4 py-1.5 text-[13px]">
          <div className="flex shrink-0 items-center gap-2">
            <span className="relative flex h-2 w-2">
              <span className="animate-live absolute inline-flex h-full w-full rounded-full bg-accent-400" />
              <span className="relative inline-flex h-2 w-2 rounded-full bg-accent-400" />
            </span>
            <span className="font-semibold tracking-wide">LIVE</span>
          </div>
          <div className="relative flex-1 overflow-hidden">
            <div className="animate-marquee flex w-max items-center gap-10 whitespace-nowrap">
              {[...tickerItems, ...tickerItems].map((item, i) => (
                <span key={i} className="flex items-center gap-10 text-background-100/90">
                  <span>{item}</span>
                  <i className="ri-circle-fill text-[4px] text-accent-400" />
                </span>
              ))}
            </div>
          </div>
          <div className="hidden shrink-0 items-center gap-2 sm:flex">
            <a href="#info" className="flex items-center gap-1 whitespace-nowrap rounded-full border border-background-50/40 px-3 py-1 hover:bg-background-50/10">
              <i className="ri-quill-pen-line text-sm" />
              <span>投稿</span>
            </a>
            <a href="#archive" className="flex items-center gap-1 whitespace-nowrap rounded-full bg-accent-500 px-3 py-1 font-semibold text-foreground-950 hover:bg-accent-400">
              <i className="ri-download-2-line text-sm" />
              <span>下载 App</span>
            </a>
          </div>
        </div>
      </div>

      {/* 主品牌导航 */}
      <header className="sticky top-0 z-50 border-b border-background-200/80 bg-background-50/90 backdrop-blur">
        <div className="mx-auto flex w-full max-w-6xl items-center justify-between px-4 py-3">
          <a href="#top" className="flex items-center gap-2">
            <h1 className="font-heading text-2xl font-black tracking-tight text-foreground-950">
              88<span className="text-primary-500">黑料</span>
            </h1>
            <span className="hidden rounded-full border border-primary-200 bg-primary-50 px-2 py-0.5 text-[11px] text-primary-700 md:inline-block">
              公众人物黑料百科
            </span>
          </a>

          <nav className="hidden items-center gap-7 lg:flex">
            {navLinks.map((l) => (
              <a
                key={l.href}
                href={l.href}
                className="whitespace-nowrap text-[15px] text-foreground-600 transition-colors hover:text-primary-600"
              >
                {l.label}
              </a>
            ))}
          </nav>

          <div className="flex items-center gap-2">
            <a
              href="#search"
              className="hidden h-9 w-9 items-center justify-center rounded-full border border-background-300 text-foreground-600 transition-colors hover:border-primary-300 hover:text-primary-600 sm:flex"
              aria-label="检索"
            >
              <i className="ri-search-line text-lg" />
            </a>
            <a
              href="#archive"
              className="hidden whitespace-nowrap rounded-full bg-primary-500 px-4 py-2 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600 sm:inline-flex sm:items-center"
            >
              开始吃瓜
            </a>
            <button
              type="button"
              aria-label="菜单"
              className="flex h-9 w-9 items-center justify-center rounded-full border border-background-300 text-foreground-700 lg:hidden"
              onClick={() => setOpen((v) => !v)}
            >
              <i className={`${open ? "ri-close-line" : "ri-menu-line"} text-lg`} />
            </button>
          </div>
        </div>

        {/* 移动端菜单 */}
        {open && (
          <div className="border-t border-background-200/70 bg-background-50 px-4 py-3 lg:hidden">
            <div className="grid grid-cols-2 gap-2">
              {navLinks.map((l) => (
                <a
                  key={l.href}
                  href={l.href}
                  onClick={() => setOpen(false)}
                  className="rounded-lg bg-background-100 px-3 py-2.5 text-[15px] text-foreground-700 hover:bg-background-200"
                >
                  {l.label}
                </a>
              ))}
            </div>
            <div className="mt-3 flex gap-2">
              <a
                href="#archive"
                className="flex flex-1 items-center justify-center gap-1 whitespace-nowrap rounded-full bg-primary-500 px-4 py-2 text-sm font-semibold text-background-50"
              >
                <i className="ri-download-2-line" /> 下载 App
              </a>
              <a
                href="#info"
                className="flex flex-1 items-center justify-center gap-1 whitespace-nowrap rounded-full border border-background-300 px-4 py-2 text-sm text-foreground-700"
              >
                <i className="ri-quill-pen-line" /> 投稿
              </a>
            </div>
          </div>
        )}
      </header>
    </>
  );
}